// GW Video Fix — patches ProductTemplate Slick init to allow video clicks
// Waits for jQuery to be ready before running. This theme defers/lazy-loads
// scripts out of normal document order, so jQuery is not guaranteed to exist
// yet when this file executes — that race caused "$ is not a function".
(function() {
  'use strict';

  function init($) {

    function fixVideoSlides() {
      var $slider = $('.product-large-slider');
      if (!$slider.length) return;

      // 1. Find all slick-slide wrappers that contain a video
      $slider.find('.slick-slide').each(function() {
        var $slide = $(this);
        if ($slide.find('video, iframe').length) {
          // Force pointer events through on the slide wrapper
          $slide.css('pointer-events', 'auto');
          $slide.find('video, iframe, .gw-native-video, .gw-external-video').css({
            'pointer-events': 'auto',
            'position': 'relative',
            'z-index': '10'
          });
          // Remove data-fancybox from anything inside video slides
          $slide.find('[data-fancybox]').removeAttr('data-fancybox');
        }
      });

      // 2. Destroy and rebind Fancybox ONLY on image slides
      try {
        // Fancybox 3 — unbind its delegated click handler from document
        $(document).off('click.fb-start');
        // Rebind only on image anchors
        var $imageLinks = $slider.find('.slick-slide:not(.slick-cloned) .fancybox-gallery');
        if ($imageLinks.length && $.fn.fancybox) {
          $imageLinks.fancybox({ loop: true });
        }
      } catch(e) {}

      // 3. For the Slick fade mode — the current slide has opacity:1 but
      // non-current slides have opacity:0 AND pointer-events:none via CSS.
      // Video slide needs pointer-events even when active.
      // Override Slick's inline styles on video slides.
      $slider.on('afterChange', function(e, slick, currentIndex) {
        // Re-apply fix after every slide change
        setTimeout(fixVideoSlides, 50);
      });
    }

    // Wait for Slick to initialise then apply fix
    function waitForSlick(tries) {
      tries = tries || 0;
      var $slider = $('.product-large-slider');
      if ($slider.hasClass('slick-initialized')) {
        fixVideoSlides();
      } else if (tries < 20) {
        setTimeout(function() { waitForSlick(tries + 1); }, 300);
      }
    }

    // Run on DOM ready and on theme lazy-load event
    $(function() {
      waitForSlick();
    });

    document.addEventListener('w3-DOMContentLoaded', function() {
      setTimeout(waitForSlick, 500);
    });

    $(window).on('load', function() {
      setTimeout(waitForSlick, 800);
    });
  }

  // 4. Intercept ALL clicks at capture phase on the slider.
  // Pure DOM, no jQuery needed — safe to run immediately regardless
  // of whether jQuery has loaded yet.
  document.addEventListener('click', function(e) {
    var videoEl = e.target.closest('video');
    if (!videoEl) return;
    // Stop everything — let the browser handle the native video click
    e.stopImmediatePropagation();
    e.stopPropagation();
    // Do NOT preventDefault — that would block the play button
  }, true); // capture phase

  // Also block mousedown at capture phase so Fancybox never gets it
  document.addEventListener('mousedown', function(e) {
    if (e.target.closest('video')) {
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('touchstart', function(e) {
    if (e.target.closest('video')) {
      e.stopImmediatePropagation();
    }
  }, { capture: true, passive: true });

  // jQuery-dependent logic: wait for jQuery to exist before running it,
  // instead of assuming it's already loaded.
  function waitForJQuery(tries) {
    tries = tries || 0;
    if (window.jQuery) {
      init(window.jQuery);
    } else if (tries < 100) {
      setTimeout(function() { waitForJQuery(tries + 1); }, 100);
    }
  }
  waitForJQuery();

})();
